<style lang="scss" scoped>
.image-gallery {
    .gallery-image {
        padding-left: 12px;
        padding-right: 12px;
        padding-bottom: 24px;

        height: 333px;
        width: 100%;
        flex: 0 100%;

        @media screen and (min-width: 768px) and (max-width: 1279.98px) {
            width: 50%;
            flex: 0 50%;
            &:last-child:nth-child(odd) {
                width: 100%;
                flex: 0 100%;
            }
        }

        @media screen and (min-width: 1280px) {
            padding-left: 20px;
            padding-right: 20px;
            padding-bottom: 40px;

            &:nth-child(7n + 1),
            &:nth-child(7n + 3),
            &:nth-child(7n + 6) {
                padding-left: 12px;
                &:last-child {
                    width: 100%;
                    flex: 0 100%;
                }
            }
            &:nth-child(7n + 2),
            &:nth-child(7n + 5),
            &:nth-child(7) {
                padding-right: 12px;
            }

            width: 100% / 3 * 1;
            flex: 0 100% / 3 * 1;
            &:nth-child(7n + 1),
            &:nth-child(7n) {
                width: 100% / 3 * 2;
                flex: 0 100% / 3 * 2;
            }

            &:nth-child(7n + 4) {
                &:last-child {
                    width: 100% / 3 * 2;
                    flex: 0 100% / 3 * 2;
                }
            }
        }

        img {
            object-fit: cover;
            font-family: "object-fit: cover;";
        }
    }
}
</style>

<template>
    <div class="image-gallery container mb-56" v-if="images">
        <div class="row">
            <div v-for="image in images" class="gallery-image" :key="image.id">
                <img class="h-100 w-100" :src="image.sizes.large">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        images: {
            type: [Array,Boolean],
            required: true
        }
    },
}
</script>